import { render, staticRenderFns } from "./TicketCard.vue?vue&type=template&id=38e6bfb9"
import script from "./TicketCard.vue?vue&type=script&lang=js"
export * from "./TicketCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports